import * as utils from './utils';
import Base from './Base';

export default class Derivative extends Base {

   static urls = {
      all: '{host}/projects/{project}/subjects/{subject}/experiments/{type}/',
      one: '{host}/projects/{project}/subjects/{subject}/experiments/{experiment}/{type}/{derivative}',
      new: '{host}/projects/{project}/subjects/{subject}/experiments/{experiment}/{type}/{derivative}?{query}',
   }

   xsiType = 'xnat:ecgScanData'

   create = utils.create()

   constructor(data) {
      super();
      this.initialize(data);
   }

   initialize(data) {
      this.data = utils.rename(data, {
         ID: 'derivative',
      });
      this.data.query = this.getQuery();
   }

   getQuery() {
      const xsiType = this.xsiType;
      return `xsiType=${xsiType}`;
   }

}
